import messages from "messages";
import styles from "./styles.module.scss";

const NoAttachment = () => (
  <div className={styles["no-attachment"]}>
    <div className={styles["no-attachment__header"]}>
      {messages.noNoteAttachments}
    </div>

    <div className={styles["no-attachment__body"]}>
      {messages.thereIsNoAttachmentFound}
    </div>
  </div>
);

export default NoAttachment;
